<template>
  <div class="h-100">
    <b-row class="integralDiagnosisView">
      <b-col class="data-col h-100">
        <b-card class="section-col component-bg">
          <div class="section-col_container">
            <b-row class="section-col_row h-100">
              <b-col class="diagnosis-content h-100">
                <b-tabs
                  v-model="tabIndexSelected"
                  pills
                  card
                  vertical
                  class="vt-tabs--vertical h-100"
                  content-class="h-100"
                >
                  <b-tab title-item-class="manuallyControlledTab">
                    <template slot="title">
                      <i
                        qa="integral-diagnosis-diagnosis-i"
                        class="section-icon fal fa-comment-alt-medical"
                        aria-hidden="true"
                      />
                      <div
                        v-if="sectionsSummary && sectionsSummary.hasText"
                        class="section-bubble"
                      />
                    </template>
                    <div
                      v-shortkey="['ctrl', '1']"
                      class="py-2 section-content"
                      @shortkey.prevent="tabIndexSelected = DIAGNOSIS_TAB_INDEX"
                    >
                      <case-diagnosis
                        v-if="tabIndexSelected === DIAGNOSIS_TAB_INDEX"
                        ref="diagnosisSection"
                        :lab-id="labId"
                        :case-data="caseData"
                        :title="$t('diagnosis.btns.comprehensiveDiagnosis')"
                        :disabled="!$_isCaseEditable(caseData && caseData.status.code)"
                        @reloadSummary="getSectionsSummary"
                      />
                    </div>
                  </b-tab>
                  <b-tab title-item-class="manuallyControlledTab">
                    <template slot="title">
                      <i
                        qa="integral-diagnosis-codifications-i"
                        class="section-icon fal fa-project-diagram"
                        aria-hidden="true"
                      />
                      <div
                        v-if="sectionsSummary && sectionsSummary.hasCodifications"
                        class="section-bubble"
                      />
                    </template>
                    <div
                      v-shortkey="['ctrl', '2']"
                      class="py-2 section-content-grid"
                      @shortkey.prevent="tabIndexSelected = CODIFICATIONS_TAB_INDEX"
                    >
                      <section-codifications
                        v-if="tabIndexSelected === CODIFICATIONS_TAB_INDEX"
                        ref="codificationsSection"
                        :disabled="!$_isCaseEditable(caseData && caseData.status.code)"
                        :codifications-service="caseCodificationServices"
                        :parent-entity-ids-array="[labId, caseId]"
                        :can-edit-codifications="$_canEditCase()"
                        @reloadSummary="getSectionsSummary"
                      />
                    </div>
                  </b-tab>
                  <b-tab title-item-class="manuallyControlledTab">
                    <template slot="title">
                      <i
                        qa="integral-diagnosis-observations-i"
                        class="section-icon fal fa-eye"
                        aria-hidden="true"
                      />
                      <div
                        v-if="sectionsSummary && sectionsSummary.hasObservations"
                        class="section-bubble"
                      />
                    </template>
                    <div
                      v-shortkey="['ctrl', '3']"
                      class="p-2 h-100"
                      @shortkey.prevent="tabIndexSelected = OBSERVATIONS_TAB_INDEX"
                    >
                      <case-observations
                        v-if="tabIndexSelected === OBSERVATIONS_TAB_INDEX"
                        ref="observationsSection"
                        :lab-id="labId"
                        :cas-id="caseId"
                        :disabled="!$_isCaseEditable(caseData && caseData.status.code)"
                        @reloadSummary="getSectionsSummary"
                      />
                    </div>
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <modal-unsaved-changes
      id="integralDiagnosisUnsavedChangesModal"
      ref="unsavedChangesModal"
    />
  </div>
</template>

<script>
import CaseDiagnosis from '@/modules/diagnosisModule/views/form/integralDiagnosisView/CaseDiagnosis'
import SectionCodifications from '@/modules/diagnosisModule/views/form/sections/SectionCodifications'
import CaseObservations from '@/modules/diagnosisModule/views/form/integralDiagnosisView/CaseObservations'
import caseCodificationServices from '@/api/resources/cases/caseCodificationServices'
import ModalUnsavedChanges from '@/components/modals/ModalUnsavedChanges'
import DiagnosisCaseService from '@/modules/diagnosisModule/services/DiagnosisCaseService'
import { CaseOperationGuardMixin } from '@/api/operations/mixins/guards/case-operation-guard.mixin'
import DiagnosisCaseMixin from '@/modules/diagnosisModule/mixins/DiagnosisCaseMixin'
import { router } from '@/router'
import { HelperUtils } from '@/shared/util/helper-utils'

const DIAGNOSIS_TAB_INDEX = 0
const CODIFICATIONS_TAB_INDEX = 1
const OBSERVATIONS_TAB_INDEX = 2

export default {
    name: 'IntegralDiagnosis',
    components: {
        CaseDiagnosis,
        SectionCodifications,
        CaseObservations,
        ModalUnsavedChanges
    },
    mixins: [
        CaseOperationGuardMixin,
        DiagnosisCaseMixin
    ],
    props: {
        labId: { type: Number, required: true }
    },
    data() {
        return {
            tabIndexSelected: DIAGNOSIS_TAB_INDEX,
            sectionsSummary: null
        }
    },
    computed: {
        caseCodificationServices() {
            return caseCodificationServices
        },
        DIAGNOSIS_TAB_INDEX() {
            return DIAGNOSIS_TAB_INDEX
        },
        CODIFICATIONS_TAB_INDEX() {
            return CODIFICATIONS_TAB_INDEX
        },
        OBSERVATIONS_TAB_INDEX() {
            return OBSERVATIONS_TAB_INDEX
        }
    },
    async mounted() {
        this.$nextTick(() => this.replaceClickOnTabEvents())
        await this.getSectionsSummary()
    },
    methods: {
        async getSectionsSummary() {
            const [err, response] = await this.toCall(DiagnosisCaseService.comprehensiveDiagnosisSectionsSummary(this.labId, this.caseId))
            if (err) {
                this.showErrorModalGlobal()
            }
            this.sectionsSummary = response
            this.$emit('updateCase')
        },
        replaceClickOnTabEvents() {
            const tabs = document.getElementsByClassName('manuallyControlledTab')
            if (tabs.length === 0) {
                setTimeout(this.replaceClickOnTabEvents, 100)
                return
            }
            for (let i = 0; i < tabs.length; i++) {
                const tab = tabs.item(i)
                tab.addEventListener('click', this.navigateToTab)
            }
        },
        navigateToTab(mouseEvent) {
            const newTabIndex = Number.parseInt(mouseEvent.currentTarget.children[0].getAttribute('aria-posinset')) - 1
            this.checkChangesInActiveTabAndApplyAction(() => {
                this.tabIndexSelected = newTabIndex
            })
        },
        async checkChangesInActiveTabAndApplyAction(goToRoute, changedLaboratory) {
            const activeTabContent = this.getActiveTabContent()
            if (changedLaboratory) {
                if (!activeTabContent) {
                    await HelperUtils.runActionsWhenChangeLaboratory(goToRoute)
                    return
                }
                if (activeTabContent.hasBeenChanged()) {
                    this.$refs.unsavedChangesModal.askAndExecuteCallbacks(
                        activeTabContent.save,
                        async () => {
                            HelperUtils.runActionsWhenChangeLaboratory(goToRoute)
                        },
                        () => { router.currentRoute.meta.skipChecking = false }
                    )
                } else {
                    HelperUtils.runActionsWhenChangeLaboratory(goToRoute)
                }
            } else {
                if (!activeTabContent) {
                    goToRoute()
                    return
                }
                if (activeTabContent.hasBeenChanged()) {
                    this.$refs.unsavedChangesModal.askAndExecuteCallbacks(
                        () => { return activeTabContent.save() },
                        goToRoute)
                } else {
                    goToRoute()
                }
            }
        },
        async saveChangesInActiveTabAndApplyAction(actionIfTrue) {
            const activeTabContent = this.getActiveTabContent()
            if (!activeTabContent) {
                actionIfTrue()
                return
            }
            if (activeTabContent.hasBeenChanged()) {
                await activeTabContent.save()
                actionIfTrue()
            } else {
                actionIfTrue()
            }
        },
        getActiveTabContent() {
            if (this.tabIndexSelected === DIAGNOSIS_TAB_INDEX) {
                return this.$refs.diagnosisSection
            } else if (this.tabIndexSelected === CODIFICATIONS_TAB_INDEX) {
                return this.$refs.codificationsSection
            } else if (this.tabIndexSelected === OBSERVATIONS_TAB_INDEX) {
                return this.$refs.observationsSection
            } else {
                return null
            }
        }
    }
}
</script>

<style>
    .integralDiagnosisView .manuallyControlledTab {
        cursor: pointer;
    }
    .integralDiagnosisView .manuallyControlledTab > a {
        pointer-events: none;
    }
</style>
